import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { PlanSection } from '../components/PlanSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
import { initPixel, trackPageView } from '../lib/pixel';
export function SalesPage() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-[#0a0f1e] font-sans text-white" data-id="element-213">
      <HeroSection data-id="element-214" />
      <ProblemSection data-id="element-215" />
      <MechanismSection data-id="element-216" />
      <PlanSection data-id="element-217" />
      <OfferSection data-id="element-218" />
      <FooterSection data-id="element-219" />
    </div>;
}